import { render, staticRenderFns } from "./SaleSetting.vue?vue&type=template&id=47d07ba6&"
import script from "./SaleSetting.vue?vue&type=script&lang=js&"
export * from "./SaleSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports